import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, AlertTriangle } from 'lucide-react';
export function PainSection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-12 px-4 bg-brand-light" data-id="element-40">
      <div className="max-w-3xl mx-auto space-y-10" data-id="element-41">
        {/* La verdad que pocos quieren admitir */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={fadeIn} className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-gray-100 relative" data-id="element-42">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-dark text-white p-2.5 rounded-full shadow-lg" data-id="element-43">
            <AlertTriangle className="w-5 h-5 text-brand-gold" data-id="element-44" />
          </div>
          <h2 className="text-2xl font-heading font-bold text-center text-brand-dark mb-5 mt-3" data-id="element-45">
            La verdad que pocos quieren admitir
          </h2>
          <div className="space-y-3 text-base text-gray-700" data-id="element-46">
            <p data-id="element-47">
              La mayoría de los agentes inmobiliarios no pierde ventas por falta
              de clientes.
            </p>
            <p className="font-bold text-lg text-red-600" data-id="element-48">
              Las pierde por desorganización.
            </p>
            <p data-id="element-49">
              Un mensaje queda enterrado. Un "te escribo mañana" nunca sucede.
              Un cliente interesado se enfría.
            </p>
            <p data-id="element-50">
              Y días —o semanas— después…{' '}
              <span className="font-semibold text-brand-dark" data-id="element-51">
                ese mismo cliente termina comprando con otro agente.
              </span>
            </p>
            <p data-id="element-52">
              No porque ese agente fuera mejor. Sino porque tuvo algo que tú no
              tenías en ese momento:
            </p>
            <p className="text-xl font-bold text-brand-blue text-center py-2" data-id="element-53">
              Un sistema.
            </p>
          </div>
        </motion.div>

        {/* Lo que está pasando ahora mismo */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={fadeIn} className="bg-brand-dark text-white p-6 md:p-8 rounded-2xl shadow-xl" data-id="element-54">
          <h2 className="text-xl md:text-2xl font-heading font-bold mb-5 text-center" data-id="element-55">
            Lo que está pasando ahora mismo{' '}
            <span className="text-brand-gold" data-id="element-56">(aunque no lo veas)</span>
          </h2>

          <ul className="space-y-3 mb-6 text-base" data-id="element-57">
            {['Leads que te escribieron… y nunca volviste a contactar', 'Clientes que preguntaron por una propiedad… y olvidaste cuál', 'Personas listas para comprar… que trataste como curiosos', 'Seguimientos que pensaste hacer… pero nunca hiciste'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-58">
                <MessageCircle className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-59" />
                <span data-id="element-60">{item}</span>
              </li>)}
          </ul>

          <div className="bg-white/10 p-4 rounded-xl border border-white/20 space-y-2" data-id="element-61">
            <p className="font-semibold text-brand-gold" data-id="element-62">
              Comisiones perdidas. Tiempo desperdiciado. Oportunidades que no
              vuelven.
            </p>
            <p className="text-lg font-bold" data-id="element-63">
              Un agente promedio pierde entre el{' '}
              <span className="text-red-400" data-id="element-64">30% y el 60%</span> de sus ventas
              potenciales por no tener un sistema de seguimiento.
            </p>
          </div>
        </motion.div>

        {/* No es falta de esfuerzo */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={fadeIn} className="text-center" data-id="element-65">
          <h3 className="text-xl font-bold text-brand-dark" data-id="element-66">
            No es falta de esfuerzo
          </h3>
          <p className="text-lg font-semibold text-brand-blue mt-1" data-id="element-67">
            Es falta de estructura.
          </p>
          <p className="mt-3 text-gray-600" data-id="element-68">
            Porque tener leads sin sistema… es como pescar con una red rota.
          </p>
          <p className="italic text-gray-500" data-id="element-69">
            Capturas oportunidades… pero se escapan una por una.
          </p>
        </motion.div>
      </div>
    </section>;
}